import { IMyAppState } from "../states/GlobalState";
import { Agency } from "../models/agency";
import { SimulazioniSrlDataClass } from "../states/SimulazioneSrlState";

export type CodiceDescrizione<TC, TD> = { codice: TC, descrizione: TD };

export enum TabIForfettari {
    Dati = 0,
    ForfettariIrpef = 1,
    IrpefNormale = 2,
    Confronto = 3,
    Report = 4,
}

export enum TipoImpresa {
    Impresa = "IMPRESA",
    Professione = "PROFESSIONE",
    Undefined = "NON DEFINITO"
}
export enum TipoRegime {
    Forfetario = "FORFETARIO",
    Normale = "NORMALE",
    Undefined = "NON DEFINITO"
}
export enum TipoPrevidenza {
    Artigianato = "ARTIGIANATO",
    Commercio = "COMMERCIO",
    Undefined = "NON DEFINITO"
}

export enum Applicazioni {
    iForfettari = 1,
    ConvSrl = 2,
    Budget4u = 3,     // Budget
    FlatTax = 4,     // Not Used
    Company = 5,
    Agency = 6,
    Principal = 7,
    WhatsNew = 8,
    ImportTelematico = 9,
    Report = 10,
    Home = 99
}

export const GruppoLookup: CodiceDescrizione<number, string>[] = [
    { codice: 0, descrizione: "Non definito" },
    { codice: 1, descrizione: "Industrie alimentari e delle bevande" },
    { codice: 2, descrizione: "Commercio all'ingrosso e al dettaglio" },
    { codice: 3, descrizione: "Commercio ambulante di prodotti alimentari e bevande" },
    { codice: 4, descrizione: "Commercio ambulante di altri prodotti" },
    { codice: 5, descrizione: "Costruzioni e attività immobiliari" },
    { codice: 6, descrizione: "Intermediari del commercio" },
    { codice: 7, descrizione: "Attività dei servizi di alloggio e ristorazione" },
    { codice: 8, descrizione: "Attività professionali, scientifiche, tecniche, ecc." },
    { codice: 9, descrizione: "Altre attività economiche" }
]

export const AliquoteGestSeparata = [24, 25.72];

export interface TelematicoData {
    CompanyId: number;
    AgencyId: number | null;
    Username: string;
    FileName: string;
}

export interface LoadTelematico {
    isConvenienza: boolean | null;
    companyId: number | null;
    agency: Agency | null;
    agencyId: number | null;
    telematicoType: string;
    year: number | null;
    cfImpresa: string;
    yearCf1: number | null;
    cfCollab1: string;
    yearCf2: number | null;
    cfCollab2: string;
    yearS3: number | null;
    cfSocio3: string;
}

export interface GestionePrevidenzialeDataClass {
    tipoPrevidenza: TipoPrevidenza;
    aliquotaSep: number;
    cassaProfessionale: boolean;
}

export interface RegimeForfettarioDataClass {
    gruppo: number;
    impostaSost: number;
    percentualeRedditivita: number;
    showWarning: boolean;
}

export interface RedditoContributiImpostaDataClass {
    //  input
    ricavi: number;
    riduzione35: boolean;
    rivalsa: boolean;
    contributiCassaProf: number;

    //  output
    redditoLordo: number;
    redditoPerIvs: number;
    contributiIvs: number;
    redditoIvsCollab1: number;
    contribIvsCollab1: number;
    redditoIvsCollab2: number;
    contribIvsCollab2: number;
    contributiIvsNetti: number;
    contributiIvsDeducibili: number;
    contributiGestSep: number;
    redditoNetto: number;
    impostaSostitutiva: number;
    warningContributi35: boolean;
    mesiWarningContributi35Netti: number;
    mesiWarningContributi35Collab1: number;
    mesiWarningContributi35Collab2: number;
}

export interface RegimeNormaleDataClass {
    //  input
    determinazioneDelReddito_G81: number;
    determinazioneDelReddito_G82: number;
    determinazioneDelReddito_G84: number;
    determinazioneDelReddito_G85: number;
    determinazioneDelReddito_G86: number;
    determinazioneDelReddito_G87: number;
    determinazioneDelReddito_G88: number;
    determinazioneDelReddito_G89: number;
    determinazioneDelValoreDellaProduzioneNetta_N81: boolean
    determinazioneDelValoreDellaProduzioneNetta_N85: number;
    determinazioneDelValoreDellaProduzioneNetta_L88: number;
    determinazioneDelValoreDellaProduzioneNetta_L92: number;

    //  output
    determinazioneDelReddito_B81: string;
    determinazioneDelReddito_B82: string;
    determinazioneDelReddito_B83: string;
    determinazioneDelReddito_B84: string;
    determinazioneDelReddito_B85: string;
    determinazioneDelReddito_B86: string;
    determinazioneDelReddito_B87: string;
    determinazioneDelReddito_B88: string;
    determinazioneDelReddito_B89: string;
    determinazioneDelReddito_B90: string;
    determinazioneDelReddito_B91: string;
    determinazioneDelReddito_B92: string;
    determinazioneDelReddito_B93: string;
    determinazioneDelReddito_G83: number;
    determinazioneDelReddito_G90: number;
    determinazioneDelReddito_G91: number;
    determinazioneDelReddito_G92: number;
    determinazioneDelReddito_G93: number;
    determinazioneDelValoreDellaProduzioneNetta_I82: string;
    determinazioneDelValoreDellaProduzioneNetta_N82: number;
    determinazioneDelValoreDellaProduzioneNetta_I83: string;
    determinazioneDelValoreDellaProduzioneNetta_N83: number;
    determinazioneDelValoreDellaProduzioneNetta_I84: string;
    determinazioneDelValoreDellaProduzioneNetta_N84: number;
    determinazioneDelValoreDellaProduzioneNetta_I85: string;
    determinazioneDelValoreDellaProduzioneNetta_I86: string;
    determinazioneDelValoreDellaProduzioneNetta_N86: number;
    determinazioneDelValoreDellaProduzioneNetta_I88: string;
    determinazioneDelValoreDellaProduzioneNetta_I89: string;
    determinazioneDelValoreDellaProduzioneNetta_N89: number;
    determinazioneDelValoreDellaProduzioneNetta_L91: number;
}

export type DialogInputProps = {
    state: IMyAppState | SimulazioniSrlDataClass;
    caricaDatiTelematicoOpen: boolean;
    handleClose: any;
    handleSubmitLoadTelematico: (values: LoadTelematico) => void;
    isConvenienza: boolean;
}

export type DefaultInputProps = {
    state: IMyAppState;
    handleChange: any;
    username: string;
    handleOpenLoadData?: any;
}

export type StateInputProp = {
    state: IMyAppState;
}

export interface ImprenditoreProfessionistaDataClass {
    redditi_M16: number;
    redditi_K16: number;
    redditi_M12: number;
    redditi_I16: number;
    redditi_I14: number;
    redditi_I13: number;
    redditi_I12: number;
    redditi_I11: number;
    redditi_I8: number;
    redditi_I9: number;
    redditi_E18: number;
    redditi_E19: number;
}

export interface Collaboratore1DataClass {
    rivalsaContrIvs_H33: number;
    redditi_E46: number;
    redditi_E47: number;
    oneriDeducibiliredditi_I35: number;
    redditoImponibile_I36: number;
    irpefLorda_I37: number;
    familiari_I39: number;
    lavDip_I40: number;
    pensione_I41: number;
    lavNonDip_I42: number;
    totDetr_I44: number;
    irpefNetta_M40: number;
    regionale_K44: number;
    comunale_M44: number;
}

export interface Collaboratore2DataClass {
    rivalsaContrIvs_H60: number;
    redditi_E73: number;
    redditi_E74: number;
    oneriDeducibiliredditi_I62: number;
    redditoImponibile_I63: number;
    irpefLorda_I64: number;
    familiari_I66: number;
    lavDip_I67: number;
    pensione_I68: number;
    lavNonDip_I69: number;
    totDetr_I71: number;
    irpefNetta_M67: number;
    regionale_K71: number;
    comunale_M71: number;
}

export interface LiquidazioneIrpefDataClass {
    //  input
    redditiDiversiDaImpresa_LavAutonomo_E98: number;
    redditiDiversiDaImpresa_LavAutonomo_E99: number;
    redditiDiversiDaImpresa_LavAutonomo_E100: number;
    redditiDiversiDaImpresa_LavAutonomo_E101: number;
    redditiDiversiDaImpresa_LavAutonomo_E102: number;
    redditiDiversiDaImpresa_LavAutonomo_E103: number;
    redditiDiversiDaImpresa_LavAutonomo_E104: number;
    redditiDiversiDaImpresa_LavAutonomo_E105: number;
    altriDatiPersonali_H99: boolean;
    altriDatiPersonali_J99: number;
    altriDatiPersonali_L101: number;
    altriDatiPersonali_L102: number;
    altriDatiPersonali_I104: number;
    altriDatiPersonali_M104: number;
    altriDatiPersonali_L99: number;
}

export interface DatiCollaboratore1DataClass {
    altriDatiPersonali_J118: number;
    //  input
    nomeCognome1: string;
    quotaReddito1: number;
    redditiDiversiDallaPartecipazione_E111: number;
    redditiDiversiDallaPartecipazione_E112: number;
    redditiDiversiDallaPartecipazione_E113: number;
    redditiDiversiDallaPartecipazione_E114: number;
    redditiDiversiDallaPartecipazione_E115: number;
    redditiDiversiDallaPartecipazione_E116: number;
    redditiDiversiDallaPartecipazione_E117: number;
    redditiDiversiDallaPartecipazione_E119: number;
    altriDatiPersonali_H112: boolean;
    altriDatiPersonali_J112: number;
    altriDatiPersonali_L112: number;
    altriDatiPersonali_L114: number;
    altriDatiPersonali_L115: number;
    altriDatiPersonali_I117: number;
    altriDatiPersonali_M117: number;
}

export interface DatiCollaboratore2DataClass {
    altriDatiPersonali_J130: number;
    //  input
    nomeCognome2: string;
    quotaReddito2: number;
    redditiDiversiDaImpresa_LavAutonomo_E123: number;
    redditiDiversiDaImpresa_LavAutonomo_E124: number;
    redditiDiversiDaImpresa_LavAutonomo_E125: number;
    redditiDiversiDaImpresa_LavAutonomo_E126: number;
    redditiDiversiDaImpresa_LavAutonomo_E127: number;
    redditiDiversiDaImpresa_LavAutonomo_E128: number;
    redditiDiversiDaImpresa_LavAutonomo_E129: number;
    redditiDiversiDaImpresa_LavAutonomo_E131: number;
    altriDatiPersonali_H124: boolean;
    altriDatiPersonali_J124: number;
    altriDatiPersonali_L124: number;
    altriDatiPersonali_L126: number;
    altriDatiPersonali_L127: number;
    altriDatiPersonali_I129: number;
    altriDatiPersonali_M129: number;
}

export class IRAP_PercDataClass {
    perc_1: number;
    perc_2: number;
    perc_3: number;
    perc_4: number;
    perc_5: number;
}

export class ADD_COM_IRPEF_PercDataClass {
    perc_1: number;
    perc_2: number;
    perc_3: number;
    perc_4: number;
    perc_5: number;
    perc_6: number;
    perc_7: number;
    perc_8: number;
    perc_9: number;
    perc_10: number;
    perc_11: number;
    perc_12: number;
    perc_13: number;
    perc_14: number;
    perc_15: number;
    perc_16: number;
    perc_17: number;
    perc_18: number;
    perc_19: number;
    perc_20: number;
    perc_21: number;
    perc_22: number;
    perc_23: number;
    perc_24: number;
    perc_25: number;
}

export class FIGLI_VALORIDataClass {
    valore_H19: number;
    valore_I19: number;
    valore_H20: number;
    valore_I20: number;
}

export class CONIUGE_VALORIDataClass {
    valore_D19: number;
    valore_E19: number;
    valore_D20: number;
    valore_E20: number;
    valore_D21: number;
    valore_E21: number;
}

export class INCREMENTI_CONIUGE_A_CARICODataClass {
    incr_K17: number;
    incr_K18: number;
    incr_K19: number;
    incr_K20: number;
    incr_K21: number;
    incr_K22: number;
}

export class DETRAZIONE_LAVORO_DIPENDENTE_VALORIDataClass {
    detr_F23: number;
    detr_G23: number;
    detr_H23: number;
    detr_I23: number;
    detr_J23: number;
    detr_F24: number;
    detr_G24: number;
    detr_H24: number;
}

export class DETRAZIONE_PENSIONE_VALORIDataClass {
    detr_F25: number;
    detr_G25: number;
    detr_H25: number;
    detr_I25: number;
    detr_J25: number;
    detr_F26: number;
    detr_G26: number;
    detr_H26: number;
}

export class DETRAZIONE_IMPRESA_LAVORO_AUTONOMO_VALORIDataClass {
    detr_G22: number;
    detr_H22: number;
    detr_I22: number;
    detr_J22: number;
}

export interface IrpefImprenditoreDataClass {
    M18: number;
    K18: number;
    M14: number;
    I18: number;
    I16: number;
    I15: number;
    I14: number;
    I13: number;
    I11: number;
    I10: number;
    I9: number;
    I29: number;
    E21: number;
    E20: number;
    E12: number;
}

export interface IrpefCollaboratore1DataClass {
    M46: number;
    K46: number;
    M42: number;
    I46: number;
    I44: number;
    I43: number;
    I42: number;
    I41: number;
    I39: number;
    I38: number;
    I37: number;
    E49: number;
    E48: number;
    H35: number;
}

export interface IrpefCollaboratore2DataClass {
    M73: number;
    K73: number;
    M69: number;
    I73: number;
    I71: number;
    I70: number;
    I69: number;
    I68: number;
    I66: number;
    I65: number;
    I64: number;
    E76: number;
    E75: number;
    H62: number;
}

export interface ConfrontoDataClass {
    D36: number;
    G33: number;
    K28_contributi: number;
    D28_contributi: number;
    K27_imposte: number;
    D27_imposte: number;
    G6_contributi: number;
    G25_totale: number;
    M25_totale: number;
    G86: number;
    M86: number;
    M84: number;
    L84: boolean;
    I84: string;
    M83: number;
    L83: boolean;
    I83: string;
    M82: number;
    L82: boolean;
    I82: string;
    M81: number;
    L81: boolean;
    I81: string;
    M80: number;
    L80: boolean;
    I80: string;
    M79: number;
    L79: boolean;
    I79: string;
    G84: number;
    E84: boolean;
    B84: string;
    G83: number;
    E83: boolean;
    B83: string;
    G82: number;
    E82: boolean;
    B82: string;
    G81: number;
    E81: boolean;
    B81: string;
    G80: number;
    E80: boolean;
    B80: string;
    G79: number;
    E79: boolean;
    B79: string;
    M78: number;
    M77: number;
    M76: number;
    G76: number;
    G77: number;
    G78: number;
    M75: number;
    G75: number;
    M74: number;
    G74: number;
    M73: number;
    M72: number;
    M71: number;
    M70: number;
    M69: number;
    G69: number;
    M68: number;
    M67: number;
    G67: number;
    M66: number;
    G66: number;
}

export interface DatiInformazioniInizialiFtDataClass {
    E106: string;
    E94: string;
    D48: number;
    D49: number;
    D47: boolean;
    D45: TipoImpresa;
    D43: string;
}

export interface GestionePrevidenzialeFtDataClass {
    M48: boolean;
    M47: number;
    M46: TipoPrevidenza;
}

export interface DeterminazioneDelRedditoFtDataClass {
    G66: number;
    B66: string;
    G65: number;
    B65: string;
    G64: number;
    B64: string;
    G63: number;
    B63: string;
    G62: number;
    B62: string;
    G61: number;
    B61: string;
    G60: number;
    B60: string;
    G59: number;
    B59: string;
    G58: number;
    B58: string;
    G57: number;
    B57: string;
    G56: number;
    B56: string;
    G55: number;
    B55: string;
    G54: number;
    B54: string;
}

export interface IrapRegimeNormaleFtDataClass {
    G77: number;
    B77: string;
    E76: number;
    B76: string;
    G74: number;
    B74: string;
    G73: number;
    B73: string;
    G72: number;
    B72: string;
    G71: number;
    B71: string;
    G69: boolean;
    G70: number;
    B70: string;
}

export interface ContributiFtDataClass {
    L61: number;
    L60: number;
    L62: number;
    J59: boolean;
    N58: number;
    N57: number;
    N56: number;
    N55: number;
    K56: number;
    K55: number;
}

export interface ImpostaSostitutivaFtDataClass {
    L66: number;
    L65: number;
}

export interface LiquidazioneIrpefDatiImprenditoreProfessionistaFtDataClass {
    M88: number;
    I88: number;
    L86: number;
    L85: number;
    L83: number;
    J83: number;
    E82: number;
    E83: number;
    E84: number;
    E85: number;
    E86: number;
    E87: number;
    E88: number;
    E89: number;
    H83: boolean;
}

export interface ImpresaFamiliareFtDataClass {
    M114: number;
    I114: number;
    L112: number;
    L111: number;
    L109: number;
    J109: number;
    E116: number;
    E114: number;
    E113: number;
    E112: number;
    E111: number;
    E110: number;
    E109: number;
    E108: number;
    M102: number;
    I102: number;
    L100: number;
    L99: number;
    L97: number;
    J97: number;
    E96: number;
    E97: number;
    E98: number;
    E99: number;
    E100: number;
    E101: number;
    E102: number;
    E104: number;
    K94: number;
    H97: boolean;
    H109: boolean;
}

export interface ImprenditoreProfessionistaFtIrpefDataClass {
    K16: number;
    M16: number;
    M12: number;
    I16: number;
    I14: number;
    I13: number;
    I12: number;
    I11: number;
    I9: number;
    I8: number;
    E19: number;
    E18: number;
}

export interface Collaboratore1FtIrpefDataClass {
    M44: number;
    K44: number;
    M40: number;
    I44: number;
    I42: number;
    I41: number;
    I40: number;
    I39: number;
    I37: number;
    I36: number;
    I35: number;
    E47: number;
    E46: number;
    H33: number;
}

export interface Collaboratore2FtIrpefDataClass {
    F58: number;
    E62: number;
    E63: number;
    E64: number;
    E66: number;
    E67: number;
    E68: number;
    E69: number;
    E71: number;
    E73: number;
    E74: number;
    H60: number;
    I62: number;
    I63: number;
    I64: number;
    I66: number;
    I67: number;
    I68: number;
    I69: number;
    I70: number;
    I71: number;
    K71: number;
    M67: number;
    M71: number;
}

export interface ImprenditoreProfessionistaFtTuttoIrpefDataClass {
    K18: number;
    M18: number;
    M14: number;
    I18: number;
    I16: number;
    I15: number;
    I14: number;
    I13: number;
    I11: number;
    I10: number;
    I9: number;
    E21: number;
    E20: number;
    E12: number;
    H7: number;
}

export interface Collaboratore1FtTuttoIrpefDataClass {
    K46: number;
    M46: number;
    M42: number;
    I46: number;
    I44: number;
    I43: number;
    I42: number;
    I41: number;
    I39: number;
    I38: number;
    I37: number;
    E49: number;
    E48: number;
}

export interface Collaboratore2FtTuttoIrpefDataClass {
    I69: number;
    I68: number;
    I66: number;
    I65: number;
    I64: number;
    E76: number;
    E75: number;
}

export interface FlatTaxDataClass {
    datiInformazioniInizialiFt: DatiInformazioniInizialiFtDataClass;
    gestionePrevidenzialeFt: GestionePrevidenzialeFtDataClass;
    determinazioneDelRedditoFt: DeterminazioneDelRedditoFtDataClass;
    irapRegimeNormaleFt: IrapRegimeNormaleFtDataClass;
    contributiFt: ContributiFtDataClass;
    impostaSostitutivaFt: ImpostaSostitutivaFtDataClass;
    liquidazioneIrpefDatiImprenditoreProfessionistaFt: LiquidazioneIrpefDatiImprenditoreProfessionistaFtDataClass;
    impresaFamiliareFt: ImpresaFamiliareFtDataClass;
    imprenditoreProfessionistaFtIrpef: ImprenditoreProfessionistaFtIrpefDataClass;
    collaboratore1FtIrpef: Collaboratore1FtIrpefDataClass;
    collaboratore2FtIrpef: Collaboratore2FtIrpefDataClass;
    imprenditoreProfessionistaFtTuttoIrpef: ImprenditoreProfessionistaFtTuttoIrpefDataClass;
    collaboratore1FtTuttoIrpef: Collaboratore1FtTuttoIrpefDataClass;
    collaboratore2FtTuttoIrpef: Collaboratore2FtTuttoIrpefDataClass;
}

// export interface InformazioniCostiDiAvvioDataClass {
//     nomeDitta: string;
//     tipologia: TipoImpresa;
//     attivita: string;
//     regime: TipoRegime;
//     E17_macchinari: number,
//     E16_fabbricato: number,
//     E37_speseVive_AcquistoAzienda: number,
//     E38_speseVive_AffittoAzienda: number,
//     E39_speseVive_AttoCostSocieta: number,
//     E40_speseVive_IscrizioneRegistroImprese: number,
//     F40_speseVive_IscrizioneRegistroImprese: number,
//     G40_speseVive_IscrizioneRegistroImprese: number,
//     E41_speseVive_IscrizioneAlbo: number,
//     F41_speseVive_IscrizioneAlbo: number,
//     G41_speseVive_IscrizioneAlbo: number,
//     E42_speseVive_AutorizzazioniPermessi: number,
// }

// export interface ContoEconomicoDataClass {

// }

// export interface ForfetarioDataClass {

// }

// export interface DatiSimulazioniSrlDataClass {
//     M198: number;
//     M196: string;
//     J198: number;
//     J197: number;
//     J196: boolean;
//     L194: number;
//     L193: number;
//     N192: number;
//     L191: number;
//     J191: number;
//     H191: boolean;
//     E199: number;
//     E197: number;
//     E196: number;
//     E195: number;
//     E194: number;
//     E193: number;
//     E192: number;
//     E191: number;
//     E190: number;
//     M184: number;
//     M182: string;
//     J184: number;
//     J183: number;
//     J182: boolean;
//     L180: number;
//     L179: number;
//     N178: number;
//     L177: number;
//     J177: number;
//     H177: boolean;
//     E185: number;
//     E183: number;
//     E182: number;
//     E181: number;
//     E180: number;
//     E179: number;
//     E178: number;
//     E177: number;
//     E176: number;
//     M169: number;
//     M167: string;
//     J169: number;
//     J168: number;
//     J167: boolean;
//     L165: number;
//     L164: number;
//     N163: number;
//     L162: number;
//     J162: number;
//     H162: boolean;
//     E170: number;
//     E168: number;
//     E167: number;
//     E166: number;
//     E165: number;
//     E164: number;
//     E163: number;
//     E162: number;
//     E161: number;
//     M155: number;
//     M153: string;
//     J155: number;
//     J154: number;
//     J153: boolean;
//     L151: number;
//     L150: number;
//     N149: number;
//     L148: number;
//     J148: number;
//     H148: boolean;
//     E156: number;
//     E154: number;
//     E153: number;
//     E152: number;
//     E151: number;
//     E150: number;
//     E149: number;
//     E148: number;
//     E147: number;
//     M139: string;
//     J139: boolean;
//     H119: boolean;
//     M126: number;
//     M124: string;
//     J126: number;
//     J125: number;
//     J124: boolean;
//     L122: number;
//     N120: number;
//     L134: number;
//     J134: number;
//     H134: boolean;
//     E127: number;
//     E125: number;
//     E124: number;
//     E123: number;
//     E122: number;
//     E121: number;
//     E120: number;
//     E119: number;
//     E118: number;
//     J111: boolean;
//     H104: string;
//     H91: string;
//     H74: string;
//     L52: string;
//     E111: number;
//     G104: number;
//     G105: number;
//     G106: number;
//     G107: number;
//     G108: number;
//     G109: number;
//     D102: number;
//     G91: number;
//     G92: number;
//     G93: number;
//     G94: number;
//     G95: number;
//     G96: number;
//     D89: number;
//     D88: number;
//     D83: number;
//     G74: number;
//     G75: number;
//     G76: number;
//     G77: number;
//     G78: number;
//     G79: number;
//     D72: number;
//     D65: number;
//     K62: number;
//     K63: number;
//     K64: number;
//     K57: number;
//     C57: string;
//     K56: number;
//     C56: string;
//     K55: number;
//     C55: string;
//     K54: number;
//     C54: string;
//     K53: number;
//     C53: string;
//     K52: number;
//     C52: string;
//     G48: string;
//     L121: number;
//     M141: number;
//     J141: number;
//     J140: number;
//     L137: number;
//     L136: number;
//     N135: number;
//     E142: number;
//     E140: number;
//     E139: number;
//     E138: number;
//     E137: number;
//     E136: number;
//     E135: number;
//     E134: number;
//     E133: number;
//     L119: number;
//     J119: number;
// }

// export interface NormaleSimulazioniSrlDataClass {
//     M99: any;
//     K99: any;
//     I97: any;
//     I95: any;
//     I93: any;
//     I92: any;
//     I91: any;
//     I89: any;
//     I88: any;
//     I87: any;
//     H85: any;
//     G85: any;
//     E101: any;
//     E100: any;
//     E73: any;
//     M68: any;
//     K68: any;
//     H54: any;
//     G54: any;
//     E70: any;
//     E69: any;
//     K37: number;
//     M37: number;
//     I37: number;
//     I35: number;
//     I33: number;
//     I31: number;
//     I30: number;
//     I29: number;
//     I27: number;
//     I26: number;
//     I25: number;
//     H23: number;
//     G23: number;
//     E39: number;
//     E38: number;
//     I11: number;
//     I12: number;
//     I13: number;
//     I14: number;
//     I34: number;
//     I56: number;
//     I57: number;
//     I58: number;
//     I60: number;
//     I61: number;
//     I62: number;
//     I64: number;
//     I65: number;
//     I66: number;
//     I68: number;
// }

// export interface SoloCompSimulazioniSrlDataClass {
//     M98: number;
//     K98: number;
//     I98: number;
//     I96: number;
//     I94: number;
//     I92: number;
//     I91: number;
//     I90: number;
//     I88: number;
//     I87: number;
//     I86: number;
//     H84: number;
//     G84: number;
//     E100: number;
//     E99: number;
//     E87: number;
//     D87: number;
//     M67: number;
//     K67: number;
//     I67: number;
//     I65: number;
//     I63: number;
//     I61: number;
//     I60: number;
//     I59: number;
//     I57: number;
//     I56: number;
//     I55: number;
//     H53: number;
//     G53: number;
//     E69: number;
//     E68: number;
//     E56: number;
//     D56: number;
//     M36: number;
//     K36: number;
//     I36: number;
//     I34: number;
//     I32: number;
//     I30: number;
//     I29: number;
//     I28: number;
//     I26: number;
//     I25: number;
//     I24: number;
//     H22: number;
//     G22: number;
//     E38: number;
//     E37: number;
//     E25: number;
//     D25: number;
//     I14: number;
//     I13: number;
//     I11: number;
//     I8: number;
// }

// export interface CompDivSimulazioniSrlDataClass {
//     M99: any;
//     K99: any;
//     M95: any;
//     K95: any;
//     M87: any;
//     I99: any;
//     I97: any;
//     I95: any;
//     I93: any;
//     I92: any;
//     I91: any;
//     I89: any;
//     I88: any;
//     I87: any;
//     H85: any;
//     G85: any;
//     E101: any;
//     E100: any;
//     E93: any;
//     E88: any;
//     D88: any;
//     M68: any;
//     K68: any;
//     M64: any;
//     K64: any;
//     M56: any;
//     I68: any;
//     I66: any;
//     I64: any;
//     I62: any;
//     I61: any;
//     I60: any;
//     I58: any;
//     I57: any;
//     I56: any;
//     H54: any;
//     G54: any;
//     E70: any;
//     E69: any;
//     E62: any;
//     E57: any;
//     D57: any;
//     M37: number;
//     K37: number;
//     M33: number;
//     K33: number;
//     I37: number;
//     I35: number;
//     I33: number;
//     I31: number;
//     I30: number;
//     I29: number;
//     I27: number;
//     I26: number;
//     I25: number;
//     H23: number;
//     G23: number;
//     M25: number;
//     E39: number;
//     E38: number;
//     E31: number;
//     E26: number;
//     D26: number;
//     I14: number;
//     I13: number;
//     I11: number;
//     I8: number;
// }

// export interface TraspSimulazioniSrlDataClass {
//     M100: any;
//     K100: any;
//     I100: any;
//     I98: any;
//     I96: any;
//     I94: any;
//     I93: any;
//     I92: any;
//     I90: any;
//     I89: any;
//     I88: any;
//     H86: any;
//     G86: any;
//     E101: any;
//     E102: any;
//     E95: any;
//     M69: any;
//     K69: any;
//     I69: any;
//     I67: any;
//     I65: any;
//     I63: any;
//     I62: any;
//     I61: any;
//     I59: any;
//     I58: any;
//     I57: any;
//     H55: any;
//     G55: any;
//     E71: any;
//     E70: any;
//     E64: any;
//     M37: number;
//     K37: number;
//     I37: number;
//     I35: number;
//     I33: number;
//     I31: number;
//     I30: number;
//     I29: number;
//     I27: number;
//     I26: number;
//     I25: number;
//     H23: number;
//     G23: number;
//     E39: number;
//     E38: number;
//     E32: number;
//     I11: number;
// }

// export interface SoloDivSimulazioniSrlDataClass {
//     M99: any;
//     K99: any;
//     M95: any;
//     K95: any;
//     M87: any;
//     I99: any;
//     I97: any;
//     I95: any;
//     I93: any;
//     I92: any;
//     I91: any;
//     I89: any;
//     I88: any;
//     I87: any;
//     H85: any;
//     G85: any;
//     E101: any;
//     E100: any;
//     E93: any;
//     M68: any;
//     K68: any;
//     M64: any;
//     K64: any;
//     M56: any;
//     I68: any;
//     I66: any;
//     I64: any;
//     I62: any;
//     I61: any;
//     I60: any;
//     I58: any;
//     I57: any;
//     I56: any;
//     H54: any;
//     G54: any;
//     E70: any;
//     E69: any;
//     E62: any;
//     K37: number;
//     M37: number;
//     M33: number;
//     K33: number;
//     M25: number;
//     I37: number;
//     I35: number;
//     I31: number;
//     I33: number;
//     I30: number;
//     I29: number;
//     I27: number;
//     I26: number;
//     I25: number;
//     H23: number;
//     G23: number;
//     E39: number;
//     E38: number;
//     E31: number;
//     I14: number;
//     I13: number;
//     I11: number;
// }

// export interface TraspCompSimulazioniSrlDataClass {
//      M98: any;
// K98: any;
// I98: any;
// I96: any;
// I94: any;
// I92: any;
// I91: any;
// I90: any;
// I88: any;
// I87: any;
// I86: any;
// H84: any;
// G84: any;
// E100: any;
// E99: any;
// E87: any;
// D87: any;
// E93: any;
// I59: any;
// I60: any;
// I61: any;
// I63: any;
// I65: any;
// I67: any;
// M67: any;
// K67: any;
// I57: any;
// I56: any;
// I55: any;
// H53: any;
// G53: any;
// E69: any;
// E68: any;
// E62: any;
// E56: any;
// D56: any;
// M36: number;
// K36: number;
// I36: number;
// I34: number;
// I32: number;
// I30: number;
// I29: number;
// I28: number;
// I26: number;
// I25: number;
// I24: number;
// H22: number;
// G22: number;
// E38: number;
// E37: number;
// E31: number;
// E25: number;
// D25: number;
// I12: number;
// I11: number;
// I8: number;
// }

// export interface SimulazioniSrlDataClass {
//     datiSimulazioniSrl: DatiSimulazioniSrlDataClass;
//     normaleSimulazioniSrl: NormaleSimulazioniSrlDataClass;
//     soloCompSimulazioniSrl: SoloCompSimulazioniSrlDataClass;
//     compDivSimulazioniSrl: CompDivSimulazioniSrlDataClass;
//     traspSimulazioniSrl: TraspSimulazioniSrlDataClass;
//     soloDivSimulazioniSrl: SoloDivSimulazioniSrlDataClass;
//     traspCompSimulazioniSrl: TraspCompSimulazioniSrlDataClass;
//     riepilogoSimulazioniSrl: RiepilogoSimulazioniSrlDataClass
// }

// export interface SchedaBudgetDataClass {
//     informazioniCostiDiAvvio: InformazioniCostiDiAvvioDataClass;
//     contoEconomico: ContoEconomicoDataClass;
//     forfetario: ForfetarioDataClass;
// }

export class RILEVANZA_FISCALE_DEI_DIVIDENDI_PercDataClass {
    perc_1: number;
    perc_2: number;
    perc_3: number;
}

export class ALIQUOTA_GESTIONE_SEPARATA_PercDataClass {
    perc_1: number;
    perc_2: number;
}

export class ARTIG_COMM_PercDataClass {
    value_1: string;
    value_2: string;
    value_3: string;
    value_4: string;
    desc_1: string;
    desc_2: string;
    desc_3: string;
    desc_4: string;
}